import * as api from '../api'
import { CREATE_NOTATION, DELETE_NOTATION, UPDATE_NOTATION } from '../constants/actionTypes.js'

// Action creator
export const createNotation = (notation, match) => async (dispatch, getState) => {
    try {

        const newNotation = notation
        newNotation.creation = Date.now()
        newNotation.idMatch = match.idMatch ? match.idMatch : match.idActu
        if(newNotation.timer === undefined)
            newNotation.timer = !match.timer || (match.statusTimer === 'off' && match.timer === 0) ? 0 : (Math.floor(match.timer/60))*60
        if(newNotation.period === undefined)
            newNotation.period = match.period ? match.period : 0

        const { data } = await api.createNotation(newNotation)

        console.log('created notation', data)

        return data;

        //dispatch( { type : CREATE_NOTATION, payload: data })
    } catch(error){
        console.log(error)
        throw error;
    }
}

export const addNote = (id, note) => async (dispatch, getState) => {
    try {
        const { data } = await api.addNote(id, {note : note})

        console.log('added note', data);

        return data;

        //dispatch({ type : UPDATE_NOTATION, payload: data})
    } catch(error){
        console.log(error)
        throw error;
    }
}

export const updateNotation = (notationDetail, id) => async (dispatch) => {
  try {
    const { data } = await api.updateNotation(id, notationDetail);
    // Si reducer pour tenir le store à jour :
    // dispatch({ type: UPDATE_NOTATION, payload: data });
    console.log('updated notation', data);
    return data; // <<--- IMPORTANT
  } catch (error) {
    // faire remonter l'erreur pour que le composant sache qu'il y a un souci
    console.error(error);
    throw error;
  }
};

export const deleteNotation = (id) => async (dispatch) => {
    try {
        await api.deleteNotation(id)

        //dispatch({ type : DELETE_NOTATION, payload: id})
    }catch(error){
        console.log(error)
        throw error;
    }
}